import { AsyncPipe, NgClass } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { ResponsiveService } from '../../../services/reponsive.service';
import { Observable } from 'rxjs';
import { LucideAngularModule } from 'lucide-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../boutons/button/button.component';

@Component({
  selector: 'app-opening',
  imports: [NgClass, LucideAngularModule, AsyncPipe, TranslateModule, ButtonComponent],
  templateUrl: './opening.component.html',
  styleUrl: './opening.component.scss'
})
export class OpeningComponent {

  @ViewChild('circle', { static: true }) circleRef!: ElementRef<HTMLDivElement>;
  @ViewChild('openingStep', { static: true }) openingStepRef!: ElementRef<HTMLDivElement>;

  @Output() getStartedClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() arrowClick: EventEmitter<void> = new EventEmitter<void>();

  // :🤳 Responsive
  smallScreen$: Observable<boolean> = this.responsiveService.small$
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  circleMaxSize: number = 800;
  openingWidthCenter: number = 0;
  openingHeightCenter: number = 0;

  @HostListener('mousemove', ['$event'])
  mouseMove($event: MouseEvent) {
    this.circleRef.nativeElement.style.transition = 'none'
    const openingHeight: number = this.openingStepRef.nativeElement.clientHeight;
    const openingWidth: number = this.openingStepRef.nativeElement.clientWidth;
    this.openingHeightCenter = openingHeight / 2;
    this.openingWidthCenter = openingWidth / 2;
    const xCenterPosition: number =  $event.x / this.openingWidthCenter;
    const yCenterPosition: number = $event.y / this.openingHeightCenter;
    const circleSize: number = ((xCenterPosition + yCenterPosition) / 2) * this.circleMaxSize;
    this.moveCircle($event.x, $event.y)
    this.changeCircleSize(circleSize)
  }

  @HostListener('mouseleave', ['$event'])
  mouseLeave(event: MouseEvent) {
    this.circleRef.nativeElement.style.transition = 'all 200ms ease-in'
    this.changeCircleSize(this.circleMaxSize)
    this.moveCircle(this.openingWidthCenter, this.openingHeightCenter)
  }

  constructor(
    private responsiveService: ResponsiveService,
  ) { }

  private changeCircleSize(size: number): void {
    const cicleSize: string = size + 'px';
    this.circleRef.nativeElement.style.borderRadius = cicleSize;
    this.circleRef.nativeElement.style.height = cicleSize;
    this.circleRef.nativeElement.style.width = cicleSize;
  }
  private moveCircle(x: number, y: number): void {
    setTimeout(() => {
      const circle: HTMLDivElement = this.circleRef.nativeElement;
      circle.style.left = x + 'px';
      circle.style.top = y + 'px';
    }, 70)
  }
}
